// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/jesperlndk/dev/client-hansenbyg-website/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/Users/jesperlndk/dev/client-hansenbyg-website/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kontakt-js": () => import("/Users/jesperlndk/dev/client-hansenbyg-website/src/pages/kontakt.js" /* webpackChunkName: "component---src-pages-kontakt-js" */),
  "component---src-pages-om-js": () => import("/Users/jesperlndk/dev/client-hansenbyg-website/src/pages/om.js" /* webpackChunkName: "component---src-pages-om-js" */)
}

